<template>
  <span
    :class="`chip chip-${type}`"
    v-if="count > 0 || forceShow"
  >
    <strong class="me-2">{{ count }}</strong>
    <p>{{ suffix }}</p>
  </span>
</template>

<script>
export default {
  props: {
    forceShow: Boolean,
    type: String,
    count: Number,
    suffix: String,
  }
}
</script>
